import { useQuery } from "@tanstack/react-query";
import { contractorDetailsApi } from "../api/contractorApi";

export const useFetchContractorDetails = (contractorId: string | null) => {

    const { data, isFetching, isPending, isError, error, refetch } = useQuery({
        queryKey: ["contractor-details", contractorId],
        queryFn: () => contractorDetailsApi.fetchResourceReliability(contractorId),
        enabled: !!contractorId,
    });

    return {
        data: data,
        isLoading: isFetching || isPending,
        isError,
        error,
        refetch,
    };

};